
import { setActivityDetailProps as setActivityDetailPropsDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    activity?: string;
}

export const setActivityDetailProps = ({
    activity,
}: Props) => setActivityDetailPropsDiagram({
    activity,
});


